import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { ReactComponent as LockIcon } from '../../../assets/images/common/icons/lock-icon.svg'
import colors from '../../../assets/styles/globals.scss'
import Logo from '../../../assets/images/logos/full-brand-logo-dark.svg'
import ButtonLink from '../../common/buttons/ButtonLink'

import classes from './ExistingCommunityErrorSection.module.scss'

const ExistingCommunityErrorSection = () => {
  const user = useSelector(state => state.user.current_user)
  const { community } = useSelector(state => state.landingAccess)

  return (
    <div className={classNames(classes.existingCommunityErrorSection, 'h-100 d-flex flex-column')}>
      <a href='https://operation36.golf' target='_blank' className='mb-3'>
        <img src={Logo} className='mb-4' alt='operation 36 logo' width={180} />
      </a>

      <header className='mb-5'>
        <LockIcon className={classes.lockIcon} />
        <h1 className={classNames(classes.title, 'mt-3')}>You are Already Part of Another Community</h1>
      </header>

      <p className='my-2'>
        This page belongs to the <span style={{ fontWeight: '700' }}>{community?.name}</span> community, but you are
        currently a member of the <span style={{ fontWeight: '700' }}>{user?.communities?.[0]?.name}</span> community.
        <br/><br/>
        Operation36 participants can only belong to one community at a time, which means you cannot view or register for
        programs in other communities.
        <br/><br/>
        If you would like to be transferred to <span style={{ fontWeight: '700' }}>{community?.name}</span> or have other questions,
        please reach out to us at <span style={{ color: colors.secondaryColor, textDecoration: 'underline' }}>support@op36golf.com</span>.
      </p>

      <ButtonLink navigateTo={`/landing/${user?.communities?.[0]?.id}`} className={classNames(classes.navigateLink, 'mt-5')} isExternal >
        Back to my community
      </ButtonLink>
    </div>
  )
}

export default ExistingCommunityErrorSection
